const l3AndL4DateComplianceCheck = (initiative, value, key) => {
  const stageToCheck = key === 'L4 date compliance check (forecast vs planned date)' ? 'L4' : 'L3';
  const currentStage = initiative.stage;

  // Find timeline entry and dates
  const timelineEntry = initiative.timeline.find((entry) => entry.stage === stageToCheck);
  const targetPlanDateString = timelineEntry?.date?.plan;
  const targetActualDateString = timelineEntry?.date?.actual;

  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);

  // 1. Check if initiative is "New" (created within last 7 days)
  if (initiative.created) {
    const createdDate = new Date(initiative.created);
    createdDate.setHours(0, 0, 0, 0);
    const daysSinceCreated = Math.ceil((currentDate.getTime() - createdDate.getTime()) / (1000 * 60 * 60 * 24));
    if (daysSinceCreated <= 7) {
      return value.includes('New');
    }
  }

  // 2. Handle "Not Planned" - no plan date for the target stage
  if (!targetPlanDateString) {
    return value.includes('Not Planned');
  }

  const plannedDate = new Date(targetPlanDateString);
  plannedDate.setHours(0, 0, 0, 0);

  // 3. If there's an actual date, check for acceleration or delay
  if (targetActualDateString) {
    const actualDate = new Date(targetActualDateString);
    actualDate.setHours(0, 0, 0, 0);

    // Calculate difference between planned and actual dates
    const plannedVsActualDiff = Math.ceil((actualDate.getTime() - plannedDate.getTime()) / (1000 * 60 * 60 * 24));

    // Accelerated: Actual date is earlier than planned date
    if (plannedVsActualDiff < 0) {
      return value.includes('Accelerated');
    }
    // Unchanged: Actual date equals planned date
    else if (plannedVsActualDiff === 0) {
      return value.includes('Unchanged');
    }
    // Delayed: Actual date is later than planned date
    else {
      const delayDays = Math.abs(plannedVsActualDiff);
      if (delayDays <= 7) return value.includes('Delayed (1 to 7 days)');
      if (delayDays <= 14) return value.includes('Delayed (8 to 14 days)');
      if (delayDays <= 30) return value.includes('Delayed (15 to 30 days)');
      if (delayDays <= 90) return value.includes('Delayed (1 to 3 months)');
      return value.includes('Delayed (more than 3 months)');
    }
  }
  const daysDifference = Math.ceil((plannedDate.getTime() - currentDate.getTime()) / (1000 * 60 * 60 * 24));
  if (currentStage === stageToCheck && daysDifference > 0) {
    return value.includes('Accelerated');
  }
  if (daysDifference === 0) {
    return value.includes('Unchanged');
  }
  if (daysDifference > 0 && currentStage !== stageToCheck) {
    return value.includes('On Plan');
  }
  if (daysDifference < 0 && currentStage !== stageToCheck) {
    const delayDays = Math.abs(daysDifference);
    if (delayDays <= 7) return value.includes('Delayed (1 to 7 days)');
    if (delayDays <= 14) return value.includes('Delayed (8 to 14 days)');
    if (delayDays <= 30) return value.includes('Delayed (15 to 30 days)');
    if (delayDays <= 90) return value.includes('Delayed (1 to 3 months)');
    return value.includes('Delayed (more than 3 months)');
  }
  return false;
};

export default l3AndL4DateComplianceCheck;